import { Inject, Injectable } from "@angular/core";
import { Actions, ofType } from "@ngrx/effects";
import { Observable } from "rxjs";
import { SECTION_TYPE } from "../../contract-control.service";
import { IProgressResponse } from "../../modals/bulk-upload-modal/upload-files.service";
import { CONTRACT_DETAIL_FACADE_TOKEN, IContractDetailFacade } from "../store/contract-detail-facade.token";
import { ContractDetailActions } from "../store/contract-detail.actions";

@Injectable({providedIn: 'root'})


export class DocumentToCCAndLinkerService {
    
    constructor( 
        private _actions$: Actions,
        @Inject(CONTRACT_DETAIL_FACADE_TOKEN) public _contractFacade: IContractDetailFacade
    ) { }
    
    /**
     * Links a document to a specific Contract Control (CC) and emits progress updates.
     *
     * @param {Object} uploadedFileResponse - The document file response information containing `name` and `id`.
     * @param {string} uploadedFileResponse.name - The name of the document to be linked.
     * @param {number} uploadedFileResponse.id - The ID of the document to be linked.
     * @param {number} contract_control_id - The ID of the contract control to link the document to.
     * @param {File} file - The file associated with the document being linked.
     * @return {Observable<IProgressResponse<T>>} An observable that emits the progress and response of the operation.
     */
    linkDocumentToCC<T>(uploadedFileResponse: {name:string, id: number},contract_control_id: number, file:File):Observable<IProgressResponse<T>>{

        return new Observable((observer)=>{
            this._actions$
                .pipe(
                    ofType(ContractDetailActions.addDocuments, ContractDetailActions.addDocumentsFailure)
                )
                .subscribe(()=>{
                    observer.next({
                        percent: 100, response: uploadedFileResponse as T, file: file
                    });
                    observer.complete();
                });



            this._contractFacade.addDocument({
                contract_control_id: contract_control_id,
                section_type: SECTION_TYPE.DOCUMENT,
                sectionable:{
                    name: uploadedFileResponse.name,
                },
                sectionable_id:uploadedFileResponse.id
            });

        })
    }
}